import React, { useContext, useState } from 'react';

// Styles & Assets
import styles from './CreatePollToolbar.module.css';
import { IoIosArrowBack } from 'react-icons/io';
import { IoIosMenu } from 'react-icons/io';

// Context
import GeneralContext from '../../context/GeneralContext';

// Components
import NavbarWrapper from '../UI/NavbarWrapper/NavbarWrapper';
import Icon from '../UI/Icon/Icon';

// Other
import { Link, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Modal from '../UI/Modal/Modal';

interface Props {
    modified: boolean
    handleSavePoll: (redirect?: string) => void
}

const CreatePollToolbar: React.FC<Props> = ({ modified, handleSavePoll }) => {

    const { t } = useTranslation();

    const navigate = useNavigate();

    const generalContext = useContext(GeneralContext);

    const handleChangeSidebarMode = () => generalContext.setOpenSidebar(prev => !prev);

    const [showModal, setShowModal] = useState(false);

    const handleClick = () => {
        if (modified) setShowModal(true);
    };

    const handleSave = () => {
        setShowModal(false);
        handleSavePoll('/home/polls');
    };

    return (
        <NavbarWrapper>
            <div className={styles.toolbarContainer}>
                {!generalContext.openSidebar &&
                    <button onClick={handleChangeSidebarMode}>
                        <Icon><IoIosMenu /></Icon>
                    </button>
                }
                {modified ?
                    <button className={styles.linkBack} onClick={handleClick}>
                        <IoIosArrowBack />
                        <p>{t('back_to') + ' '}
                            <span className={styles.patientsUnderline}>
                                {t('polls')}
                            </span>
                        </p></button>
                    :
                    <Link to={'/home/polls'} className={styles.linkBack}>
                        <IoIosArrowBack />
                        <p>{t('back_to') + ' '}
                            <span className={styles.patientsUnderline}>
                                {t('polls')}
                            </span>
                        </p>
                    </Link>
                }
            </div>
            <Modal show={showModal} setShowModal={setShowModal} >
                <div className='dialog'>
                    <h1 className='dialogTitle'>{t('sure_leave_without_saving')}</h1>
                    <div className={styles.buttonsContainer}>
                        <button className={'button btnPrimary'} onClick={handleSave}>
                            {t('save')}
                        </button>
                        <button className={'button btnSecondary'} onClick={() => navigate('/home/polls')}>
                            {t('dont_save')}
                        </button>
                    </div>
                </div>
            </Modal>
        </NavbarWrapper>
    );
};

export default CreatePollToolbar;